// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.new_offer .is-valid {\n    border-color: rgb(206, 212, 218) !important;\n    background: #fff !important;\n}\n", ""]);
// Exports
module.exports = exports;
